export { CrmContactProfilePageComponent } from './contact-profile.component';
